import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, ArrowRight } from 'lucide-react';
import { useAppDispatch } from '@/store';
import { apiSlice } from '@/store/api/apiSlice';

const BillingSuccess: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(apiSlice.util.invalidateTags(['Billing', 'OrgProducts']));
    const timer = setTimeout(() => {
      navigate('/billing');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate, dispatch]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#000000]">
      <div className="section-card max-w-md w-full text-center">
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 rounded-full bg-green-500/20 flex items-center justify-center">
            <CheckCircle className="w-10 h-10 text-green-400" />
          </div>
        </div>

        <h1 className="text-2xl font-bold text-[#F5F5F7] mb-3">Subscription activated</h1>
        <p className="text-[#86868B] mb-6">
          Your payment was successful. Billing and product access will update within a few moments.
        </p>

        <div className="space-y-3">
          <button
            onClick={() => navigate('/billing')}
            className="w-full btn-t btn-t-primary flex items-center justify-center gap-2"
          >
            Go to Billing
            <ArrowRight className="w-4 h-4" />
          </button>
          <button onClick={() => navigate('/dashboard')} className="w-full btn-t">
            Back to Dashboard
          </button>
        </div>

        <p className="text-xs text-[#86868B] mt-6">Redirecting to billing in 5 seconds…</p>
      </div>
    </div>
  );
};

export default BillingSuccess;
